export const ROOM_UI_HIDE = {
  backButton: "back-button",
  destinations: "destinations",
  inviteGuests: "invite-guests",
  recording: "recording"
} as const;
